<app-festival-decoration></app-festival-decoration>
<div class="header-menu" [class.scrolled]="isScrolled" [class.client-summary-open]="showClientSummarySlider">
	<!-- Top Navigation -->
	<nav class="nav-top">
		<!-- Logo Section -->
		<div class="logo-section" [class.show-logo]="!layoutService.showSidebar()">
			<a href="/" class="logo">
				@if (themeService.getTheme() === 'light') {
					<span class="normal">
						<img src="assets/images/header/light_mode_img.svg" alt="">
					</span>
				}
				@if (themeService.getTheme() === 'dark') {
					<span class="normal">
						<img src="assets/images/header/dark_mode_img.svg" alt="">
					</span>
				}
			</a>

			<!-- Right Controls (logo left, controls right from ≤1199) -->
			<div class="controls-right">
				<!-- AI Help Assistant -->
				<app-ai-help-assistant-fab placement="header" />

				<!-- Theme Toggle (full pill on desktop; compact icon on mobile) -->
				<div class="theme-toggle-switch"
					[class.dark-mode]="themeService.getTheme() === 'dark'"
					[class.is-toggling]="themeIconAnimating"
					(click)="toggleTheme()"
					role="button"
					tabindex="0"
					[attr.aria-label]="themeService.getTheme() === 'light' ? 'Switch to Night Mode' : 'Switch to Day Mode'"
					[matTooltip]="themeService.getTheme() === 'light' ? 'Switch to Night Mode' : 'Switch to Day Mode'"
					matTooltipAlways
					(keydown.enter)="toggleTheme()"
					(keydown.space)="$event.preventDefault(); toggleTheme()">
					@if (themeService.getTheme() === 'light') {
					<span class="toggle-label">Day Mode</span>
					}
					@if (themeService.getTheme() === 'dark') {
					<span class="toggle-label">Night Mode</span>
					}
					<div class="toggle-icon">
						<span class="toggle-icon__spin">
							<i class="wl_icon_Sun toggle-icon__sun" aria-hidden="true"></i>
							<i class="wl_icon_night-mode toggle-icon__moon" aria-hidden="true"></i>
						</span>
					</div>
				</div>

				<!-- Notifications Toggle: tooltip only on bell so it does not show while hovering the open panel -->
				<div class="notifications-toggle">
					<div class="notifications-trigger" matTooltip="Notifications" matTooltipAlways (click)="toggleNotifications($event)"
						role="button" tabindex="0" (keydown.enter)="toggleNotifications($event)"
						(keydown.space)="$event.preventDefault(); toggleNotifications($event)">
						<i class="wl_icon_notification"></i>
						@if (unreadNotifications() > 0) {
						<span class="notifications-badge">{{ unreadNotifications()
							}}</span>
						}
					</div>
					@if (notificationsOpen()) {
					<app-notification-dropdown class="notification-dropdown-wrapper"
						(viewAll)="onViewAllNotifications()"
						(notificationClicked)="onNotificationClicked()"></app-notification-dropdown>
					}
				</div>

				<!-- Feedback Button -->
				<button type="button" class="header-icon-btn feedback-header-btn" matTooltip="Feedback" matTooltipAlways
					(click)="onFeedbackClick()">
					<span class="feedback-label">Feedback</span>
				</button>

				<!-- Settings Button -->
				<button type="button" class="header-icon-btn" matTooltip="Settings" matTooltipAlways (click)="onSettingsClick()">
					<i class="wl_icon_head-gear"></i>
				</button>

				<!-- People Button: Managers only (anchor so right-click → Open in new tab works) -->
				@if (isManagerUser()) {
				<a
					href="#/people"
					class="header-icon-btn"
					matTooltip="People"
					matTooltipAlways
					(click)="onPeopleClick($event)"
				>
					<i class="wl_icon_people"></i>
				</a>
				}

				<!-- User Profile -->
				<div class="profile" [ngClass]="{ 'active': isDropdownOpen }" (click)="toggleDropdown($event)">
					<div class="avatar">
						@if (hasUserImage()) {
							<img [src]="userImage" alt="User Avatar" (error)="onAvatarImageError($event)">
							<div class="avatar-placeholder" [style.background-color]="getAvatarColor(userId || '')" style="display: none;">
								{{ getInitials(userName || '') }}
							</div>
						} @else {
							<div class="avatar-placeholder" [style.background-color]="getAvatarColor(userId || '')">
								{{ getInitials(userName || '') }}
							</div>
						}
					</div>
					<div class="drp_wrp">
						<i class="fas fa-chevron-down"></i>
					</div>
				</div>
			</div>
		</div>

		<!-- Navigation Right Section -->
		<div class="nav-right">
			<!-- Main Navigation Section -->
			<div class="nav-section">
				<!-- Mobile Navigation Toggle -->
				<!-- <button class="mobile-nav-toggle" [class.active]="navActive" (click)="toggleNav()">
					<div class="hamburger">
						<span></span>
						<span></span>
						<span></span>
					</div>
				</button> -->
				<!-- Left Section -->
				<div class="nav-left">
					<ul class="nav-links">
						@for (item of headerItems; track item.name + '-' + item.to + '-' + item.type) {
						@if (isHeaderMoreButton(item)) {
						<li
							class="header-more"
							[class.is-open]="headerMoreOpen()"
							[class.is-active]="isHeaderMoreHighlighted(item)"
							(mouseenter)="openHeaderMore()"
							(mouseleave)="scheduleCloseHeaderMore()"
							(click)="$event.stopPropagation()">
							<button
								type="button"
								class="header-more__btn"
								aria-label="More"
								aria-haspopup="true"
								[attr.aria-expanded]="headerMoreOpen()"
								(click)="toggleHeaderMore($event)">
								<i class="header-more__icon" [ngClass]="item.icon || 'fas fa-ellipsis-v'" aria-hidden="true"></i>
							</button>
							<ul class="header-more__menu">
								@for (dropItem of getHeaderMoreItems(item); track dropItem.name + '-' + dropItem.to + '-' + dropItem.label) {
								@if (getHeaderMoreItemRoute(dropItem)) {
								<li class="header-more__item">
									<a
										class="header-more__link"
										[class.active]="isHeaderMoreItemActive(dropItem)"
										[attr.href]="'#' + getHeaderMoreItemRoute(dropItem)"
										(click)="onHeaderMoreItemClick($event, getHeaderMoreItemRoute(dropItem), dropItem)">
										{{ dropItem.label }}
									</a>
								</li>
								}
								}
							</ul>
						</li>
						} @else if (item.type !== 'button' && !item.dropDown?.length) {
						<li>
							<a class="nav-item"
								[class.active]="isHeaderNavHighlighted(item)"
								[class.nav-item--timesheet-attention]="isTimesheetAttentionItem(item)"
								[attr.href]="'#' + item.to"
								(click)="onHeaderNavClick($event, item)">
								@if (item.icon) {
								<i [class]="item.icon"></i>
								}
								<span>{{ item.label }}</span>
							</a>
						</li>
						}
						}
						<!-- <li class="more-menu-item">
							<div class="more-dropdown-container">
								<button class="more-button" (click)="toggleMoreDropdown($event)"
									[class.active]="moreDropdownOpen()">
									<i class="more-icon-desktop" [class.rotated]="moreDropdownOpen()">
										<svg width="3" height="14" viewBox="0 0 3 14" fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M1.50143 3.58686C1.11983 3.58686 0.80183 3.45477 0.547428 3.19058C0.293027 2.9264 0.165826 2.6084 0.165826 2.23658C0.165826 1.84519 0.293027 1.5223 0.547428 1.2679C0.80183 1.00371 1.11983 0.871616 1.50143 0.871616C1.89282 0.871616 2.21082 1.00371 2.45544 1.2679C2.70984 1.5223 2.83704 1.84519 2.83704 2.23658C2.83704 2.6084 2.70984 2.9264 2.45544 3.19058C2.21082 3.45477 1.89282 3.58686 1.50143 3.58686ZM1.50143 8.58686C1.11983 8.58686 0.80183 8.45477 0.547428 8.19058C0.293027 7.9264 0.165826 7.6084 0.165826 7.23658C0.165826 6.84519 0.293027 6.5223 0.547428 6.2679C0.80183 6.00371 1.11983 5.87162 1.50143 5.87162C1.89282 5.87162 2.21082 6.00371 2.45544 6.2679C2.70984 6.5223 2.83704 6.84519 2.83704 7.23658C2.83704 7.6084 2.70984 7.9264 2.45544 8.19058C2.21082 8.45477 1.89282 8.58686 1.50143 8.58686ZM1.50143 13.5869C1.11983 13.5869 0.80183 13.4548 0.547428 13.1906C0.293027 12.9264 0.165826 12.6084 0.165826 12.2366C0.165826 11.8452 0.293027 11.5223 0.547428 11.2679C0.80183 11.0037 1.11983 10.8716 1.50143 10.8716C1.89282 10.8716 2.21082 11.0037 2.45544 11.2679C2.70984 11.5223 2.83704 11.8452 2.83704 12.2366C2.83704 12.6084 2.70984 12.9264 2.45544 13.1906C2.21082 13.4548 1.89282 13.5869 1.50143 13.5869Z"
												fill="#353668" />
										</svg>
									</i>
									<span class="more-text-mobile">More</span>
								</button>
								<div class="more-dropdown" *ngIf="moreDropdownOpen()" (click)="$event.stopPropagation()"
									[class.dropdown-open]="moreDropdownOpen()">
									<div data-tooltip="Coming Soon" class="dropdown-item"
										(click)="onMoreItemClick('Queues')">
										<i class="fas fa-list"></i>
										<span>Queues</span>
									</div>
									<div data-tooltip="Coming Soon" class="dropdown-item"
										(click)="onMoreItemClick('Reports')">
										<i class="fas fa-chart-bar"></i>
										<span>Portfolios</span>
									</div>
									<div data-tooltip="Coming Soon" class="dropdown-item"
										(click)="onMoreItemClick('Analytics')">
										<i class="fas fa-chart-line"></i>
										<span>Content</span>
									</div>
									<div data-tooltip="Coming Soon" class="dropdown-item"
										(click)="onMoreItemClick('Help')">
										<i class="fas fa-question-circle"></i>
										<span>Support</span>
									</div>
								</div>
							</div>
						</li> -->
					</ul>
				</div>
			</div>

			<!-- Bottom Navigation -->
			<div class="nav-bottom">
				<div class="search_and_recently">
					<!-- Search Section -->
					<div class="search-section" [class.collapsed]="recentlyViewedExpanded()"
						[class.disabled]="searchDisabled()"
						(click)="onCollapsedSearchSectionClick($event)">
						<!-- Coming Soon Watermark -->
						<!-- <div class="coming-soon-overlay" *ngIf="searchDisabled() && !recentlyViewedExpanded()">
							<div class="coming-soon-content">
								<i class="fas fa-clock"></i>
								<span>Coming Soon</span>
							</div>
						</div> -->

						@if (!recentlyViewedExpanded() && !searchDisabled()) {
							<div class="dropdown" (click)="toggleSearchDropdown($event)">
								<span>{{ getSearchOptionDisplayLabel(selectedSearchOption()) }}</span>
								<img src="assets/images/down-arrow.png" alt="down-arrow" class="down-arrow">
							@if (searchDropdownOpen()) {
									<div class="dropdown-menu">
										<div class="dropdown-item" (click)="selectSearchOption('All')">
											<i class="wl_icon_ser1"></i>
											<span>All</span>
										</div>
										<div class="dropdown-item" (click)="selectSearchOption('Portfolios')">
											<i class="wl_icon_ser2"></i>
											<span>Clients</span>
										</div>
										<div class="dropdown-item" (click)="selectSearchOption('Projects')">
											<i class="wl_icon_ser3"></i>
											<span>Projects</span>
										</div>
										<div class="dropdown-item" (click)="selectSearchOption('Tasks')">
											<i class="wl_icon_ser4"></i>
											<span>Tasks</span>
										</div>
										<div class="dropdown-item" (click)="selectSearchOption('Issues')">
											<i class="wl_icon_ser5"></i>
											<span>Issues</span>
										</div>
										<div class="dropdown-item" (click)="selectSearchOption('Revisions')">
											<i class="wl_icon_revisions"></i>
											<span>Revisions</span>
										</div>
										<div class="dropdown-item" (click)="selectSearchOption('Requests')">
											<i class="wl_icon_request"></i>
											<span>Requests</span>
										</div>
								<!-- <div class="dropdown-item" (click)="selectSearchOption('Billing')">
									<i class="wl_icon_ser12"></i>
									<span>Billing</span>
								</div> -->
								<!-- <div class="dropdown-item" (click)="selectSearchOption('Reports')">
									<i class="wl_icon_ser6"></i>
									<span>Reports</span>
								</div> -->
								<div class="dropdown-item" (click)="selectSearchOption('People')">
											<i class="wl_icon_ser7"></i>
											<span>People</span>
										</div>
										<div class="dropdown-item" (click)="selectSearchOption('Documents')">
											<i class="wl_icon_ser8"></i>
											<span>Documents</span>
										</div>
										<div class="dropdown-item" (click)="selectSearchOption('Comments')">
											<i class="wl_icon_ser9"></i>
											<span>Comments</span>
										</div>
									</div>
								}
							</div>
						<input #headerSearchInput type="text" [placeholder]="'Search ' + getSearchOptionDisplayLabel(selectedSearchOption()) + ''"
								[ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)"
								(keyup.enter)="onSearch()"
								[disabled]="searchDisabled()">
						}
						<button class="search-btn" (click)="onSearchButtonClick($event)">
							<i class="wl_icon_Search"></i>
						</button>
					</div>

					<!-- Recently Viewed -->
					<div class="recently-viewed" [class.expanded]="recentlyViewedExpanded()">
						<span class="tag sml" (click)="toggleRecentlyViewed()"
							[class.rotated]="!recentlyViewedExpanded()">➤</span>
						<div class="recent_items" (mouseover)="showRecentArrows = true"
							(mouseleave)="showRecentArrows = true">
							@if (showRecentArrows && canScrollLeft) {
								<a class="nav-arrow prev"
									(click)="scrollRecentItems('left')">
									<i class="fas fa-chevron-left"></i>
								</a>
							}
							<div class="items-container" #itemsContainer>
								<!-- Show recent items if available -->
								<!-- <ng-container *ngIf="recentItems().length > 0">
									<ng-container *ngFor="let item of recentItems()"> -->
									@if (recentItems().length > 0) {
									@for (item of recentItems(); track item._id) {
										@if (item) {
											<a class="recent-item"
												[href]="'#/projects/project-details/' + item._id"
												(click)="onRecentItemClick(item, $event)" [matTooltip]="item.projectName"
												role="link" tabindex="0" (keydown.enter)="onRecentItemClick(item, $event)"
												(keydown.space)="onRecentItemClick(item, $event)">
												{{ item.projectName }}
											</a>
									<!-- </ng-container>
								</ng-container> -->
								}
									}
								} @else {
								<!-- Show message when no recent items -->
								<div class="no-recent-items">
										<i class="fas fa-clock"></i>
										<span>No recent items</span>
									</div>
								}
							</div>
								@if (showRecentArrows && canScrollRight) {
								<a class="nav-arrow next"
									(click)="scrollRecentItems('right')">
									<i class="fas fa-chevron-right"></i>
								</a>
							}
						</div>
						<div class="tag" (click)="toggleRecentlyViewed()">Recently Viewed</div>
					</div>
				</div>

				<!-- My Widgets Button -->
				@if (showWidgetsBtn) {
					<button class="my-widgets-btn" (click)="onMyWidgetsClick()"
						[attr.aria-label]="'My Widgets'">
						<img src="assets/images/widgets.png" alt="my-widgets">
						My Widgets
					</button>
				}
				@if (showClientSummaryButton) {
					<button class="client_summary_btn" (click)="onClientSummaryClick()">
						<span class="icon_svg" aria-hidden="true"
							style="display: inline-flex; align-items: center; margin-right: 5px;">
							<i class="wl_icon_View-Client-Summery"></i>
						</span>
						<span class="btn_text">View Client Summary</span>
					</button>
				}

				<!-- Sidebar Collapse Button -->
				<button class="sidebar-collapse-btn" (click)="toggleSidebar()">
					<div class="hamburger" [class.active]="isSidebarCollapsed">
						<span></span>
						<span></span>
						<span></span>
					</div>
				</button>
			</div>
		</div>
	</nav>


	<!-- Profile Dropdown -->
	<!-- <div class="profile-dropdown" *ngIf="dropdownOpen()">
		<div class="user-info">
			<a class="name clickable" href="/people/peopleview/{{userId}}" target="_blank">{{userName}}</a>
		</div>

		<a class="dropdown-item" (click)="onSettingsClick()">
			<i class="wl_icon_settings"></i>
			My Settings
		</a>
		<button class="dropdown-item" (click)="onThemeBtnClick()">
			<i class="fas fa-palette"></i>
			Theme
		</button>
		<button class="dropdown-item" (click)="toggleChangePasswordForm()">
			<i class="fas fa-key"></i>
			Change Password
		</button>
		<div class="dropdown-divider"></div>
		<button class="dropdown-item" (click)="logout()">
			<i class="fas fa-sign-out-alt"></i>
			Sign Out
		</button>
	</div> -->
	@if (showClientSummarySlider) {
	<app-client-summary-slider
		[context]="getSliderContext()"
		[contentFilter]="getSliderContentFilter()"
		[companyId]="getSliderCompanyId()"
		[initialInvoices]="getSliderInitialInvoices()"
		[initialInvoiceFromAddress]="getSliderInvoiceFromAddress()"
		(close)="onCloseClientSummarySlider()">
	</app-client-summary-slider>
	}
	@if (showMyWidgetsSlider) {
	<app-my-widgets-slider  (close)="onCloseMyWidgetsSlider()">
	</app-my-widgets-slider>
	}
	@if (showFeedbackSlider) {
	<app-feedback-form (close)="onCloseFeedbackSlider()"></app-feedback-form>
	}
	@if (showAddRequestForm) {
	<app-add-request-form
		#headerAddRequestForm
		(requestSubmitted)="onHeaderAddRequestSubmitted($event)"
		(close)="closeAddRequestForm()"
	>
	</app-add-request-form>
	}

</div>

<!-- Mobile Footer Menu - Outside header for independent positioning -->
<div class="mobile-footer-menu" [class.mobile-footer-menu--hidden]="showAddRequestForm">
	<div class="footer-menu-item" (click)="onFooterMenuClick('dashboard')"
		[class.active]="isFooterMenuActive('dashboard')">
		<div class="footer-icon">
			<i class="wl_icon_dashboard"></i>
		</div>
		<span class="footer-label">My Dashboard</span>
	</div>
	<div class="footer-menu-item" (click)="onFooterMenuClick('requests')"
		[class.active]="isFooterMenuActive('requests')">
		<div class="footer-icon">
			<i class="wl_icon_req"></i>
		</div>
		<span class="footer-label">My Requests</span>
	</div>
	<div class="footer-menu-item" (click)="onFooterMenuClick('timesheets')"
		[class.active]="isFooterMenuActive('timesheets')">
		<div class="footer-icon">
			<i class="wl_icon_offset"></i>
		</div>
		<span class="footer-label">My Timesheets</span>
	</div>
</div>
